<script setup>
import { useProductStore } from '../../../stores/fpe';
import { ElCollapseItem, ElSwitch } from 'element-plus';
import { ArrowRightBold } from '@element-plus/icons-vue';
import Uploader from '../../utility/media-uploader.vue';
import WYSIWYG from '../../utility/wysiwyg.vue';
import { storeToRefs } from 'pinia';
import { computed, defineProps, ref } from 'vue';

const store = useProductStore();
const { strings, selectedVariationDetails, product} = storeToRefs(store);
const attributes = product.value.attributes || [];

const filterAttributes = computed(() => {
    const newAttributes = [];
    attributes.forEach(attribute => {
        let processedOptions = [];
        if (Array.isArray(attribute.options)) {
            processedOptions = attribute.options.map(option => {
                if (typeof option === 'object' && option !== null) {
                    return { label: option.label, value: option.slug !== undefined ? option.slug : (option.value !== undefined ? option.value : option.label) };
                }
                return { label: option, value: option };
            });
        }
        newAttributes.push({
            name: attribute.name,
            options: processedOptions,
            variation: attribute.variation,
            id: attribute.id,
            key: convertStringToKey(attribute.name)
        });
    });
    return newAttributes;
});

const convertStringToKey = (str) => {
    return str.toLowerCase().replace(/\s+/g, '-');
}


</script>
<template>
<el-collapse-item :title="strings.section_title_attributes" class="pe-variation-attributes-details" name="attributes" :icon="ArrowRightBold">
    <div class="fpe-field-wrapper" data-field="attributes">
        
        <div class="fpe-variation-attributes">
            <div v-for="(attribute, index) in filterAttributes" :key="index" class="fpe-variation-attribute" :class="`fpe-default-form-attribut-${attribute.name}`">
                <label class="fpe-variation-attribute-name " v-if="attribute.variation">
                    {{ attribute.name }}
                </label>
                <div class="fpe-variation-attribute-options" v-if="attribute.variation">
                    <ElSelect v-model="selectedVariationDetails.attributes[attribute.key]" placeholder="Select an option">
                        <ElOption v-for="(option, idx) in attribute.options" :key="idx" :label="option.label" :value="option.value" />
                    </ElSelect>
                </div>
            </div>
        </div>
    </div>
</el-collapse-item>
</template>
